import { p as proxyCustomElement, H, d as createEvent, h, c as Host } from './p-92c4a1ea.js';
import { V as findElementInEventPath, am as hasValue, ac as KeydownManager, ad as KeydownTemplate, a6 as FocusType, aa as KeydownLifecycleMethod, e as requestTimeout } from './p-a57042e3.js';
import { b as accessibility } from './p-756e7dc5.js';
import { u as useRef } from './p-e952b680.js';
import { a as ComponentUtils } from './p-de830ba7.js';
import { O as OnElementResize } from './p-b909e6d2.js';
const tabsCss = ".sc-owc-tabs-h{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;position:relative;max-width:100%;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;margin:0;padding:0;outline:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transition:all 0.25s ease;transition:all 0.25s ease;white-space:nowrap;overflow:auto;max-height:100%}.sc-owc-tabs-h [slot=action].sc-owc-tabs{-ms-flex-item-align:center;align-self:center}.sc-owc-tabs-h .owc-tabs__indicator.sc-owc-tabs{position:absolute;background-color:transparent;-webkit-transition-property:left width;transition-property:left width;-webkit-transition-duration:500ms;transition-duration:500ms;-webkit-transition-timing-function:cubic-bezier(0.35, 0, 0.25, 1);transition-timing-function:cubic-bezier(0.35, 0, 0.25, 1);z-index:2}.owc-tabs--animating.sc-owc-tabs-h:not(.owc-tabs--first-render) .owc-tabs__indicator.sc-owc-tabs{background-color:var(--one-color-interaction-active-brand-base)}.owc-tabs--animating.sc-owc-tabs-h:not(.owc-tabs--first-render) owc-tab.sc-owc-tabs::after{-webkit-box-shadow:none !important;box-shadow:none !important;-webkit-transition-property:-webkit-box-shadow;transition-property:-webkit-box-shadow;transition-property:box-shadow;transition-property:box-shadow, -webkit-box-shadow;-webkit-transition-delay:150ms;transition-delay:150ms}.owc-tabs--animating.owc-tabs--variant-secondary.sc-owc-tabs-h:not(.owc-tabs--first-render) .owc-tabs__indicator.sc-owc-tabs{background-color:var(--one-color-interaction-active-base)}.sc-owc-tabs-h::after{content:\"\";position:absolute;background-color:var(--one-color-background-contrast);z-index:1}@media (forced-colors: active){.sc-owc-tabs-h::after{background-color:canvastext}}.owc-tabs--divider-bottom.sc-owc-tabs-h::after{height:var(--one-spacing-outline-regular);width:calc(var(--tabs-width, 100%) - var(--one-spacing-outline-regular));bottom:0;left:0;right:0}.owc-tabs--divider-top.sc-owc-tabs-h::after{height:var(--one-spacing-outline-regular);width:calc(var(--tabs-width, 100%) - var(--one-spacing-outline-regular));top:0;left:0;right:0}.owc-tabs--divider-right.sc-owc-tabs-h::after{height:var(--tabs-height, 100%);width:var(--one-spacing-outline-regular);right:0;top:0;bottom:0}.owc-tabs--divider-left.sc-owc-tabs-h::after{height:var(--tabs-height, 100%);width:var(--one-spacing-outline-regular);left:0;top:0;bottom:0}.owc-tabs--direction-horizontal.sc-owc-tabs-h{-ms-flex-direction:row;flex-direction:row}.owc-tabs--direction-horizontal.sc-owc-tabs-h .owc-tabs__indicator.sc-owc-tabs{bottom:0;height:var(--one-spacing-outline-semibold)}.owc-tabs--direction-horizontal.owc-tabs--divider-left.sc-owc-tabs-h::after{display:none}.owc-tabs--direction-horizontal.owc-tabs--divider-right.sc-owc-tabs-h::after{display:none}.owc-tabs--direction-horizontal.owc-tabs--divider-none.sc-owc-tabs-h::after{display:none}.owc-tabs--direction-horizontal.owc-tabs--elevated-positive.sc-owc-tabs-h{-webkit-box-shadow:var(--one-elevation-box-shadow-2);box-shadow:var(--one-elevation-box-shadow-2)}.owc-tabs--direction-horizontal.owc-tabs--elevated-negative.sc-owc-tabs-h{-webkit-box-shadow:var(--one-elevation-box-shadow-negative-2);box-shadow:var(--one-elevation-box-shadow-negative-2)}.owc-tabs--direction-vertical.sc-owc-tabs-h{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:start;justify-content:flex-start}.owc-tabs--direction-vertical.sc-owc-tabs-h .owc-tabs__indicator.sc-owc-tabs{left:0;width:var(--one-spacing-outline-semibold)}.owc-tabs--direction-vertical.owc-tabs--divider-bottom.sc-owc-tabs-h::after{display:none}.owc-tabs--direction-vertical.owc-tabs--divider-top.sc-owc-tabs-h::after{display:none}.owc-tabs--direction-vertical.owc-tabs--divider-none.sc-owc-tabs-h::after{display:none}.owc-tabs--direction-vertical.owc-tabs--elevated-positive.sc-owc-tabs-h{-webkit-box-shadow:var(--one-spacing-outline-semibold) 0 var(--one-spacing-outline-bold) rgba(0, 0, 0, 0.4);box-shadow:var(--one-spacing-outline-semibold) 0 var(--one-spacing-outline-bold) rgba(0, 0, 0, 0.4)}.owc-tabs--direction-vertical.owc-tabs--elevated-negative.sc-owc-tabs-h{-webkit-box-shadow:calc(var(--one-spacing-outline-semibold) * -1) 0 var(--one-spacing-outline-bold) rgba(0, 0, 0, 0.4);box-shadow:calc(var(--one-spacing-outline-semibold) * -1) 0 var(--one-spacing-outline-bold) rgba(0, 0, 0, 0.4)}";
const OwcTabsStyle0 = tabsCss;
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const TAG_TAB = 'owc-tab';
const INDICATOR_ANIMATION_DURATION = 500;
const TABS_HEIGHT = '--tabs-height';
const TABS_WIDTH = '--tabs-width';
const ACTION_SLOT_NAME = 'action';
const Tabs = /*@__PURE__*/proxyCustomElement(class Tabs extends H {
  constructor() {
    super();
    this.__registerHost();
    this.valueChange = createEvent(this, "valueChange", 3);
    this.indicatorElement = useRef();
    this.onTabClick = event => {
      const item = findElementInEventPath(event, TAG_TAB);
      if (item && !item.disabled && hasValue(item.value)) {
        this.setValue(item.value);
        this.component.keydownManager().setCurrentItem(item, {
          event
        }, false);
      }
    };
    this.setValue = newValue => {
      if (this.value !== newValue) {
        if (this.controlled) {
          this.valueChange.emit(newValue);
        } else {
          this.value = newValue;
        }
      }
    };
    this.getItems = () => Array.from(this.hostElement.querySelectorAll(TAG_TAB));
    this.getSelectableItems = () => this.getItems().filter(item => !item.disabled);
    this.propagateAttributesToItems = () => {
      this.getItems().forEach(item => {
        item.controlled = this.controlled;
        item.tabIndex = -1;
        item.variant = this.variant;
        item.configuration = this.configuration;
        item.size = this.size;
        item.disableRipple = this.disableRipple;
        item.direction = this.direction;
      });
    };
    this.component = new ComponentUtils(this).withKeydownManager([KeydownManager.Templates[KeydownTemplate.GROUP], {
      focusType: FocusType.BY_CLASS,
      selector: () => this.getSelectableItems(),
      actualSelectedItem: () => this.getSelectableItems().find(item => item.value === this.value),
      lifecycleHandlers: {
        [KeydownLifecycleMethod.ITEM_CHANGE]: ({
          items,
          current
        }) => {
          var _a, _b;
          this.activeTabId = ((_a = items[current]) === null || _a === void 0 ? void 0 : _a.id) || undefined;
          (_b = this.hostElement) === null || _b === void 0 ? void 0 : _b.focus();
        }
      }
    }]);
    this.value = undefined;
    this.elevated = 'none';
    this.divider = 'none';
    this.variant = 'primary';
    this.configuration = 'horizontal';
    this.size = 'medium';
    this.disableRipple = false;
    this.direction = 'horizontal';
    this.controlled = false;
    this.isIndicatorAnimating = false;
    this.isFirstRender = true;
    this.activeTabId = undefined;
  }
  onValueChanged(newValue, oldValue) {
    if (newValue !== oldValue) {
      !this.controlled && this.valueChange.emit(newValue);
      this.updateSelectedTab();
    }
  }
  onSizeChanged() {
    this.updateSelectedTab();
    this.isFirstRender = true;
  }
  onDirectionChanged(newValue, oldValue) {
    if (newValue !== oldValue) {
      this.isFirstRender = true;
      this.updateSelectedTab(true);
    }
  }
  componentDidLoad() {
    var _a;
    this.updateSelectedTab();
    this.activeTabId = (_a = this.getSelectableItems().find(e => e.selected) || this.getSelectableItems()[0]) === null || _a === void 0 ? void 0 : _a.id;
    this.propagateAttributesToItems();
    this.calculationTabsMeasure();
  }
  componentWillRender() {
    this.propagateAttributesToItems();
  }
  updateSelectedTab(clean = false) {
    const tabs = this.getItems();
    let selectedTab;
    for (const tab of tabs) {
      tab.selected = hasValue(tab.value) && tab.value === this.value;
      tab.selected && (selectedTab = tab);
      tab.tabIndex = -1;
    }
    this.setIndicator(selectedTab, clean);
  }
  onElementResized() {
    this.calculationTabsMeasure();
  }
  calculationTabsMeasure() {
    var _a, _b, _c, _d, _e, _f;
    if (this.direction === 'horizontal') {
      (_a = this.hostElement.style) === null || _a === void 0 ? void 0 : _a.removeProperty(TABS_HEIGHT);
      (_b = this.hostElement.style) === null || _b === void 0 ? void 0 : _b.removeProperty(TABS_WIDTH);
      (_c = this.hostElement.style) === null || _c === void 0 ? void 0 : _c.setProperty(TABS_WIDTH, `${this.hostElement.scrollWidth}px`);
    } else {
      (_d = this.hostElement.style) === null || _d === void 0 ? void 0 : _d.removeProperty(TABS_WIDTH);
      (_e = this.hostElement.style) === null || _e === void 0 ? void 0 : _e.removeProperty(TABS_HEIGHT);
      (_f = this.hostElement.style) === null || _f === void 0 ? void 0 : _f.setProperty(TABS_HEIGHT, `${this.hostElement.scrollHeight}px`);
    }
  }
  setIndicator(el, clean = false) {
    if (el) {
      this.isIndicatorAnimating = true;
      setTimeout(() => {
        this.isIndicatorAnimating = false;
        this.isFirstRender = false;
      }, INDICATOR_ANIMATION_DURATION);
    }
    requestTimeout(() => {
      if (!this.indicatorElement.current) {
        return;
      }
      const hostRect = this.hostElement.getBoundingClientRect();
      const elRect = el === null || el === void 0 ? void 0 : el.getBoundingClientRect();
      this.setIndicatorPosition(elRect, hostRect, clean);
    });
  }
  setIndicatorPosition(elRect, hostRect, clean) {
    if (!this.indicatorElement.current) {
      return;
    }
    if (this.direction === 'horizontal') {
      const parentLeft = hostRect === null || hostRect === void 0 ? void 0 : hostRect.x;
      const parentScrollLeft = this.hostElement.scrollLeft || 0;
      const tabWidth = elRect === null || elRect === void 0 ? void 0 : elRect.width;
      const tabLeft = (elRect === null || elRect === void 0 ? void 0 : elRect.x) - parentLeft + parentScrollLeft;
      if (clean) {
        this.indicatorElement.current.style.removeProperty('height');
        this.indicatorElement.current.style.removeProperty('top');
      }
      this.indicatorElement.current.style.setProperty('width', tabWidth ? `${tabWidth}px` : '0');
      this.indicatorElement.current.style.setProperty('left', tabLeft ? `${tabLeft}px` : '0');
    } else {
      const parentTop = hostRect === null || hostRect === void 0 ? void 0 : hostRect.y;
      const parentScrollHeight = this.hostElement.scrollTop || 0;
      const tabHeight = elRect === null || elRect === void 0 ? void 0 : elRect.height;
      const tabTop = (elRect === null || elRect === void 0 ? void 0 : elRect.y) - parentTop + parentScrollHeight;
      if (clean) {
        this.indicatorElement.current.style.removeProperty('width');
        this.indicatorElement.current.style.removeProperty('left');
      }
      this.indicatorElement.current.style.setProperty('height', tabHeight ? `${tabHeight}px` : '0');
      this.indicatorElement.current.style.setProperty('top', tabTop ? `${tabTop}px` : '0');
    }
  }
  render() {
    const hostClasses = this.component.getHostBemClasses({
      [`elevated-${this.elevated || 'none'}`]: true,
      [`divider-${this.divider || 'none'}`]: true,
      [`variant-${this.variant || 'primary'}`]: true,
      [`direction-${this.direction || 'horizontal'}`]: true,
      'first-render': this.isFirstRender,
      animating: this.isIndicatorAnimating
    });
    const indicatorClasses = this.component.getChildBemClasses('indicator', hostClasses);
    return h(Host, Object.assign({
      key: '3d74965993e023d7dc3f8d6d4ce6ddeb2a179e06',
      class: hostClasses,
      tabIndex: this.component.getInitialTabIndex(0),
      onClick: this.onTabClick
    }, accessibility({
      role: 'tablist',
      aria: {
        activedescendant: this.activeTabId
      }
    })), h("div", {
      key: '2b224e4d3e27830ee33f898a4d280a8d3822ec2a',
      class: indicatorClasses,
      ref: this.indicatorElement
    }), h("slot", {
      key: '5b701cb4cbbbb0bc0e90c5f123718835865e5c36'
    }), h("slot", {
      key: 'aac45d525552e79bd5ba6ad38091b97968bd444a',
      name: ACTION_SLOT_NAME
    }));
  }
  get hostElement() {
    return this;
  }
  static get watchers() {
    return {
      "value": ["onValueChanged"],
      "size": ["onSizeChanged"],
      "configuration": ["onDirectionChanged"],
      "direction": ["onDirectionChanged"]
    };
  }
  static get style() {
    return OwcTabsStyle0;
  }
}, [6, "owc-tabs", {
  "value": [1537],
  "elevated": [513],
  "divider": [513],
  "variant": [513],
  "configuration": [513],
  "size": [513],
  "disableRipple": [516, "disable-ripple"],
  "direction": [513],
  "controlled": [516],
  "isIndicatorAnimating": [32],
  "isFirstRender": [32],
  "activeTabId": [32]
}, undefined, {
  "value": ["onValueChanged"],
  "size": ["onSizeChanged"],
  "configuration": ["onDirectionChanged"],
  "direction": ["onDirectionChanged"]
}]);
__decorate([OnElementResize({
  target: hostInstance => hostInstance.hostElement
})], Tabs.prototype, "onElementResized", null);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-tabs"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-tabs":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Tabs);
        }
        break;
    }
  });
}
const OwcTabs = Tabs;
const defineCustomElement = defineCustomElement$1;
export { OwcTabs, defineCustomElement };